import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { FileText, Plus, UserCheck, Users } from 'lucide-react';

const DashboardPage = ({ payrollStats, runningTotalPayrollDashboard, thisMonthPayroll, setActiveMenuItem }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <Card className="glass shadow-lg border-0">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Total Payroll Employees</CardTitle>
          <Users className="h-4 w-4 text-blue-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{payrollStats.total_payroll_employees}</div>
        </CardContent>
      </Card>

      <Card className="glass shadow-lg border-0">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Active Employees</CardTitle>
          <UserCheck className="h-4 w-4 text-green-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{payrollStats.active_employees}</div>
        </CardContent>
      </Card>

      <Card className="glass shadow-lg border-0">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Minimum Wage Employees</CardTitle>
          <FileText className="h-4 w-4 text-orange-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{payrollStats.minimum_wage_employees}</div>
        </CardContent>
      </Card>

      <Card className="glass shadow-lg border-0">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Above Minimum Wage</CardTitle>
          <FileText className="h-4 w-4 text-purple-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{payrollStats.above_minimum_wage_employees}</div>
        </CardContent>
      </Card>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      <Card className="glass shadow-lg border-0">
        <CardHeader>
          <CardTitle className="text-lg font-semibold text-gray-900 dark:text-white">Monthly Payroll Summary</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 dark:text-gray-200">Total Running Payroll:</span>
            <span className="text-lg font-bold text-teal-700">₱{runningTotalPayrollDashboard.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 dark:text-gray-200">Total Monthly Payroll:</span>
            <span className="text-lg font-bold text-green-600">₱{payrollStats.total_monthly_payroll?.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 dark:text-gray-200">This Month Payroll:</span>
            <span className="text-lg font-bold text-indigo-700">₱{thisMonthPayroll.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 dark:text-gray-200">Average Salary:</span>
            <span className="text-lg font-bold text-blue-600">₱{payrollStats.average_salary?.toLocaleString()}</span>
          </div>
        </CardContent>
      </Card>

      <Card className="glass shadow-lg border-0">
        <CardHeader>
          <CardTitle className="text-lg font-semibold text-gray-900 dark:text-white">Quick Actions</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button
            onClick={() => setActiveMenuItem('new-employee')}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          >
            <Plus className="h-4 w-4 mr-2" />
            Register New Employee
          </Button>
          <Button
            onClick={() => setActiveMenuItem('employee-management')}
            variant="outline"
            className="w-full"
          >
            <Users className="h-4 w-4 mr-2" />
            Manage Employees
          </Button>
          <Button
            onClick={() => setActiveMenuItem('payslip')}
            variant="outline"
            className="w-full"
          >
            <FileText className="h-4 w-4 mr-2" />
            Generate Payslips
          </Button>
        </CardContent>
      </Card>
    </div>
  </div>
);

export default DashboardPage;

